<template>
  <div v-if="isPermission">
    <CRow>
      <CCol lg="7" md="12" sm="12">
        <CCard style="border-radius: 10px">
          <CCardBody>
            <CRow class="">
              <CCol col="3">
                <span style="cursor: pointer" id="memberDetailBackButton" @click="goback"
                  ><i
                    class="fi fi-rr-arrow-left mr-2"
                    style="position: relative; top: 2px"
                  ></i
                  >{{ $t("back") }}</span
                >
              </CCol>
              <CCol col="9" class="d-flex justify-content-end align-items-center">
                <router-link
                  v-if="isEditMember"
                  class="text-success"
                  style="text-decoration: none; font-size: 18px"
                  :to="`/member/${objectId}/editmember`"
                  id="memberDetailEditLink"
                >
                  <i class="fi fi-rr-edit"></i>
                </router-link>
              </CCol>
            </CRow>
            <CRow>
              <!-- Avatar อยู่ทางซ้าย -->
              <CCol
                md="3"
                class="text-center d-flex align-items-center justify-content-center"
              >
                <div>
                  <img
                    v-if="data.avatar"
                    class="img-fluid rounded-circle"
                    width="80%"
                    :src="data.avatar"
                    id="memberDetailAvatar"
                    onerror="this.onerror=null;this.src='https://cdn-icons-png.flaticon.com/512/149/149071.png';"
                  />
                  <div v-else class="d-flex align-items-center justify-content-center">
                    <div class="circle" id="memberDetailNoAvatar">
                      {{ catIcon(firstname) }}
                    </div>
                  </div>
                </div>
              </CCol>

              <!-- ข้อมูลสมาชิกอยู่ทางขวา -->
              <CCol md="9">
                <CRow>
                  <CCol md="12" class="d-flex justify-content-between align-items-center">
                    <h1 class="font-weight-normal mt-3" id="memberDetailName">
                      {{ firstname }}
                      <img
                        v-if="isMember === 'line'"
                        :src="imgSrc"
                        width="3%"
                        class="img-fluid"
                        id="memberDetailLineIcon"
                      />
                    </h1>
                  </CCol>
                </CRow>
                <p class="font-weight-normal">
                  <i class="fi fi-rr-circle-p mr-2" style="color: var(--success)"></i>
                  {{ data.point }} {{ $t("pointtxt") }}
                </p>

                <CRow class="mt-3">
                  <CCol md="6">
                    <p class="font-weight-normal">
                      <i class="fi fi-rr-circle-user mr-2"></i>
                      {{ formatGender(data.sex) }}
                    </p>
                    <p class="font-weight-normal">
                      <i class="fi fi-rr-calendar mr-2"></i>
                      {{ data.dateOfBirth ? showBirthDate(data.dateOfBirth) : '-' }}
                    </p>
                    <p class="font-weight-normal">
                      <i class="fi fi-rr-phone-call mr-2"></i> {{ data.phone || "-" }}
                    </p>
                    <p class="font-weight-normal">
                      <i class="fi fi-rr-envelope mr-2"></i> {{ data.email || "-" }}
                    </p>
                  </CCol>
                  <CCol md="6"> </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="5" md="12" sm="12" >
        <CCard style="border-radius: 10px;height:94.5%;">
          <CCardBody>
            <CRow>
              <CCol class="border-right text-success pt-2">
                <div class="d-flex align-items-center">
                  <div class="mr-auto">
                    <h4 id="memberDetailTotalValue">{{ $t("totaValue") }}</h4>
                  </div>
                  <div>
                    <h5 class="text-dark" id="memberDetailBillCount">
                      {{ bill }} {{ $t("bill") }}
                    </h5>
                  </div>
                </div>
                <h1 class="font-weight-normal text-center pt-5 pb-4" id="memberDetailGrandTotal">
                  {{ convertCurrency(grandTotal) }}
                </h1>
              </CCol>
              <CCol class="text-warning pt-2">
                <h4 class="" id="memberDetailAvgBill">{{ $t("averageBill") }}</h4>
                <h1 class="font-weight-normal text-center  pt-5 pb-4" id="memberDetailAvgBillValue">
                  {{ avgBill }}
                </h1>
              </CCol>
              <!-- <CCol class="border-left text-danger">
            <div class="d-flex">
              <div class="mr-auto">
                <h5 class="">บิลที่เปิดอยู่</h5>
              </div>
              <div>
                <h5 class="text-black">0 บิล</h5>
              </div>
            </div>
            <h1 class="font-weight-bold text-center">0.00</h1>
          </CCol> -->
            </CRow>
            <h5
              id="memberDetailPurchaseDetail"
              class="mt-4 text-center text-description"
              @click="getTransaction()"
            >
              {{ $t("purchaseDetail") }} >
            </h5>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!-- เพิ่มส่วน Notes หลังจาก CRow ของ Frequently และ Recent Purchase -->
    <CRow>
      <CCol md="12">
        <CCard >
          <CCardBody>
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h4 class="mb-0">{{ $t('shopNotes') }}</h4>
              <CButton color="success" variant="outline" size="sm" @click="openNoteModal()">
                {{ $t('addNote') }}
              </CButton>
            </div>

            <!-- ส่วนแสดงรายการแบบเลื่อนได้ -->
            <div class="d-flex overflow-auto " style="gap: 15px; scrollbar-width: thin;">
              <CCard v-for="(note, index) in notes" :key="index" 
                    style="min-width: 300px; flex: 0 0 300px; border: 1px solid #e0e0e0; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.05);">
                <CCardBody>
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <strong style="font-size: 1.1em; 
                      color: #333; 
                      flex: 1; 
                      margin-right: 10px;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      line-height: 1.4em; /* กำหนด line-height ให้สัมพันธ์กับ font-size */
                      max-height: 2.8em;  /* 1.4em * 2 บรรทัด */">
                      {{ note.title }}
                    </strong>
                    
                    <CBadge :color="getStatusColor(note.status)" shape="pill" style="white-space: nowrap;" v-if="note.status && note.status !== 'none'">
                      {{ getStatusLabel(note.status) }}
                    </CBadge>
                  </div>
                  
                  <div class="d-flex flex-wrap mb-2" style="gap: 5px;">
                    <CBadge v-for="tagValue in note.tags" 
                            :key="tagValue" 
                            :color="getTagColor(tagValue)"
                            shape="pill">
                      {{ getTagLabel(tagValue) }}
                    </CBadge>
                  </div>
                  
                  <div class="text-muted mb-3" 
                      style="height: 40px; overflow-y: auto; font-size: 0.9em; padding-right: 5px; scrollbar-width: thin;">
                    {{ note.detail }}
                  </div>

                  <div class="d-flex justify-content-between align-items-end mt-2 pt-2" style="border-top: 1px solid #eee;">
                    <div class="d-flex flex-column" style="font-size: 0.75em; color: #888; line-height: 1.2;">
                      <span title="สร้างเมื่อ">{{ $t('createdAt') }}: {{ showDate(note.created_at) }}</span>
                      <span title="แก้ไขล่าสุด">{{ $t('updatedAt') }}: {{ showDate(note.updated_at) }}</span>
                    </div>

                    <div class="d-flex align-items-center">
                      <CButton 
                        size="sm" 
                        variant="ghost" 
                        color="primary" 
                        class="p-1 mr-1" 
                        @click="openNoteModal(note)"
                      >
                        <i class="fi fi-rr-edit"></i>
                      </CButton>
                      <CButton 
                        size="sm" 
                        variant="ghost" 
                        color="danger" 
                        class="p-1" 
                        @click="deleteNote(note)"
                      >
                        <i class="fi fi-rr-trash"></i>
                      </CButton>
                    </div>
                  </div>
                </CCardBody>
              </CCard>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol lg="6" md="6" sm="12">
        <CCard style="border-radius: 10px">
          <CCardBody v-if="frequencyPurchase.length > 0">
            <h4 id="memberDetailFrequentlyTitle">{{ $t("frequently") }}</h4>
            <CListGroup class="list-group-flush">
              <div v-for="(item, index) in frequencyPurchase" :key="index">
                <template v-if="index < 5">
                  <CListGroupItem
                    class="pl-0 pr-0 border-bottom"
                    :id="`memberDetailFrequentlyItem-${index}`"
                  >
                    <table style="width: 100%">
                      <tr>
                        <td style="width: 10%" valign="top">
                          <div
                            v-if="item.remoteImagePath"
                            class="square-box"
                            :style="{
                              'background-image': `url('${item.remoteImagePath}'), url('${noImg}')`,
                              'background-size': 'cover',
                              'background-position': 'center center',
                              width: '100%',
                            }"
                            :id="`memberDetailFrequentlyItemImage-${index}`"
                          ></div>
                          <div
                            v-else
                            class="square-box"
                            :style="{
                              backgroundColor: item.backgroundColor,
                              width: '100%',
                              'background-origin': 'content-box',
                            }"
                            :id="`memberDetailFrequentlyItemNoImage-${index}`"
                          ></div>
                        </td>
                        <td class="pl-2" valign="top">
                          <h5
                            class="text-dark"
                            :id="`memberDetailFrequentlyItemName-${index}`"
                          >
                            {{ item.pluName }}
                          </h5>
                          <h6
                            class="text-muted text-dark"
                            :id="`memberDetailFrequentlyItemCode-${index}`"
                          >
                            {{ item.pluCode }}
                          </h6>
                        </td>

                        <td style="width: 30%" class="text-right" valign="top">
                          <h6
                            class="text-dark text-right"
                            :id="`memberDetailFrequentlyItemQuantity-${index}`"
                          >
                            <b>{{ item.quantity }} </b>
                          </h6>
                          <h6
                            class="text-muted"
                            :id="`memberDetailFrequentlyItemAmount-${index}`"
                          >
                            {{ convertCurrency(item.netAmount) }}
                          </h6>
                        </td>
                      </tr>
                    </table>
                  </CListGroupItem>
                </template>
              </div>
            </CListGroup>
          </CCardBody>
          <CCardBody v-else>
            <h4 id="memberDetailFrequentlyTitleNoItems">{{ $t("frequently") }}</h4>
            <CJumbotron class="mt-3 mb-0" id="memberDetailFrequentlyNoItems">
              <h4 class="text-muted text-center text-dark">{{ $t("noItem") }}</h4>
            </CJumbotron>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol lg="6" md="6" sm="12">
        <CCard style="border-radius: 10px">
          <CCardBody v-if="lastPurchase.length > 0">
            <h4 id="memberDetailRecentPurchaseTitle">
              {{ $t("recentPurchase") }}
            </h4>
            <CListGroup class="list-group-flush">
              <div v-for="(item, index) in lastPurchase" :key="index">
                <template v-if="index < 5">
                  <CListGroupItem
                    class="pl-0 pr-0 border-bottom"
                    :id="`memberDetailRecentPurchaseItem-${index}`"
                  >
                    <table style="width: 100%">
                      <tr>
                        <td valign="top">
                          <h5
                            class="text-dark"
                            :id="`memberDetailRecentPurchaseReceipt-${index}`"
                          >
                            {{ item.receiptNumber }}
                          </h5>
                          <h6
                            class="text-muted text-dark"
                            :id="`memberDetailRecentPurchaseDate-${index}`"
                          >
                            {{ showDatetime(item.created_at) }}
                          </h6>
                        </td>

                        <td style="width: 30%" class="text-right text-dark" valign="top">
                          <h6
                            class="text-muted"
                            :id="`memberDetailRecentPurchaseAmount-${index}`"
                          >
                            {{ convertCurrency(item.grandTotal) }}
                          </h6>
                        </td>
                      </tr>
                    </table>
                  </CListGroupItem>
                </template>
              </div>
            </CListGroup>
          </CCardBody>
          <CCardBody v-else>
            <h4 class="font-weight-normal" id="memberDetailRecentPurchaseTitleNoItems">
              {{ $t("recentPurchase") }}
            </h4>
            <CJumbotron class="mt-3 mb-0" id="memberDetailRecentPurchaseNoItems">
              <h4 class="text-muted text-center text-dark">{{ $t("noItem") }}</h4>
            </CJumbotron>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal :title="$t('noteModalTitle')" :show.sync="showNoteModal">
      <CForm>
        <!-- ใช้ $t สำหรับ Label และ Placeholder -->
        <CInput :label="$t('title')" v-model="noteForm.title" :placeholder="$t('enterTitle')" />
        <CTextarea :label="$t('detail')" v-model="noteForm.detail" rows="3" :placeholder="$t('enterDetail')" />
        
        <label>{{ $t('status') }}:</label>
        <CSelect
          :options="translatedStatusOptions"
          :value.sync="noteForm.status"
        />
        
        <label>{{ $t('tags') }}:</label>
        <div class="d-flex flex-wrap" style="gap: 8px;">
          <CButton 
            v-for="tag in tagOptions" 
            :key="tag.value"
            size="sm"
            :color="getTagColor(tag.value)"
            :variant="noteForm.tags.includes(tag.value) ? '' : 'outline'"
            @click="toggleTag(tag.value)"
          >
            {{ getTagLabel(tag.value) }}
          </CButton>
        </div>
      </CForm>
      <template #footer>
        <CButton color="secondary" @click="showNoteModal = false">{{ $t('cancel') }}</CButton>
        <CButton color="success" @click="saveNote">{{ $t('save') }}</CButton>
      </template>
    </CModal>
  </div>
  <div v-else>
    <access-data id="memberDetailNoPermission"></access-data>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pos from "@/services/local";
import moment from "moment";
import util from "@/util/util";
import permis from "@/util/permission";
import { CCardBody } from "@coreui/vue";

export default {
  data() {
    return {
      data: {},
      firstname: "",
      lastname: "",
      loadingButton: false,
      deletedAt: null,
      frequencyPurchase: [],
      lastPurchase: [],
      grandTotal: 0,
      bill: 0,
      details: [],
      imgSrc: "../../../img/line-icon.png",
      isMember: "",
      showNoteModal: false,
      notes: [], 
      isEditMode: false,
      statusOptions: [
        { value: 'none', label: 'ไม่มีสถานะ' },
        { value: 'open', label: 'รอดำเนินการ' },
        { value: 'in-progress', label: 'กำลังดำเนินการ' },
        { value: 'resolved', label: 'ปิดเคส' }
      ],
      // 2. รายการ Tags ทั้งหมด
      tagOptions: [
        { value: 'general', label: 'ทั่วไป' },
        { value: 'vip', label: 'VIP' },
        { value: 'important', label: 'สำคัญ' },
        { value: 'complaint', label: 'ข้อร้องเรียน' },
        { value: 'feedback', label: 'ข้อเสนอแนะ' },
        { value: 'waiting-customer', label: 'รอข้อมูลลูกค้า' }
      ],
      noteForm: {
        status: 'none',
        title: "",
        detail: "",
        tags: []
      },
      newNote: { text: '', tag: 'general' }, // สำหรับฟอร์มเพิ่ม/แก้ไข
      isEditingNote: false
      };
  },
  computed: {
    ...mapGetters(["shops", "users"]),
    isPermission() {
      return permis.findPermissionRead("member", "/member/data");
    },
    isEditMember() {
      return permis.findPermissionEdit("member", "/member/data");
    },
    uid() {
      return `${localStorage.getItem("shopsUid")}`;
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    objectId() {
      return this.$route.params.objectId;
    },
    avgBill() {
      if (this.grandTotal) {
        let avg = this.grandTotal / this.bill;
        return this.convertCurrency(avg);
      } else {
        return "0.00";
      }
    },
    noImg() {
      return process.env.VUE_APP_NOIMAGE;
    },
    translatedStatusOptions() {
      return this.statusOptions.map(option => ({
        ...option,
        label: this.getStatusLabel(option.value) // ดึง label ที่แปลแล้ว
      }));
    }
  },
  created() {
    this.getMemberByObjectId();
    this.getMemberDashboard();
    this.getNotes();
  },
  methods: {
    getStatusColor(statusValue) {
    const statusMap = {
      'none': 'light',
      'open': 'secondary',
      'in-progress': 'info',
      'resolved': 'success'
    };
    return statusMap[statusValue] || 'secondary';
  },

  // ฟังก์ชันดึงชื่อภาษาไทยของ Status
  getStatusLabel(statusValue) {
    const statusMap = {
      'none': this.$t('statusNone'),
      'open': this.$t('statusOpen'),
      'in-progress': this.$t('statusInProgress'),
      'resolved': this.$t('statusResolved')
    };
    return statusMap[statusValue] || statusValue;
  },
   getTagColor(tagValue) {
      const colorMap = {
        'general': 'secondary',    // สีเทา: ทั่วไป
        'vip': 'success',          // สีเขียว: คนสำคัญ
        'important': 'danger',     // สีแดง: สำคัญมาก
        'follow-up': 'warning',    // สีเหลือง: ต้องติดตาม
        'complaint': 'danger',     // สีแดง: ข้อร้องเรียน (ต้องการการจัดการด่วน)
        'feedback': 'info',        // สีฟ้า: ข้อเสนอแนะ
        'waiting-customer': 'dark',// สีดำ/เทาเข้ม: รอข้อมูลลูกค้า
        'internal': 'light'        // สีขาว/เทาอ่อน: บันทึกภายใน
      };
      
      // ถ้าไม่พบใน map ให้คืนค่า 'info' เป็นค่าเริ่มต้น
      return colorMap[tagValue] || 'info';
    },
    toggleTag(tagValue) {
      const index = this.noteForm.tags.indexOf(tagValue);
      if (index === -1) {
        this.noteForm.tags.push(tagValue); // ถ้ายังไม่มีให้เพิ่ม
      } else {
        this.noteForm.tags.splice(index, 1); // ถ้ามีแล้วให้ลบออก
      }
    },
   getTagLabel(tagValue) {
    // แปลง 'follow-up' เป็น 'FollowUp' เพื่อให้ตรงกับคีย์ 'tagFollowUp'
    const key = tagValue.split('-').map(part => 
      part.charAt(0).toUpperCase() + part.slice(1)
    ).join('');
    
    return this.$t(`tag${key}`);
  },
    // เพิ่มฟังก์ชันนี้เข้าไปครับ
    openNoteModal(note = null) {
      if (note) {
        this.noteForm = { 
          ...note, 
          tags: note.tags || [] // ถ้า note.tags เป็น undefined ให้เปลี่ยนเป็น []
        };
        this.isEditMode = true;
      } else {
        this.noteForm = { 
          status: 'open', 
          title: "", 
          detail: "", 
          tags: [] 
        };
        this.isEditMode = false;
      }
      this.showNoteModal = true;
    },
    saveNote() {
      const isEdit = !!this.noteForm.objectId; // เช็คว่ามี objectId หรือไม่
      const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) };
      
      // เลือก URL และ Method ตามโหมดการทำงาน
      const url = isEdit 
        ? `/api/v3.0/membernotes/update/${this.noteForm.objectId}` 
        : `/api/v3.0/membernotes/create`;
      const method = isEdit ? "patch" : "post";

      const payload = {
        shopObjectId: this.shopObjectId,
        memberObjectId: this.objectId,
        title: this.noteForm.title,
        status: this.noteForm.status,
        detail: this.noteForm.detail,
        tags: this.noteForm.tags,
      };

      pos({
        method: method,
        url: url,
        data: payload,
        headers: headers
      })
      .then((res) => {
        console.log(isEdit ? "แก้ไขสำเร็จ:" : "บันทึกสำเร็จ:", res.data);
        this.showNoteModal = false;
        this.getNotes(); 
      })
      .catch((error) => {
        console.error("เกิดข้อผิดพลาด:", error);
        alert("ไม่สามารถบันทึกข้อมูลได้");
      });
    },
    deleteNote(note) {
      if (!confirm("คุณต้องการลบบันทึกนี้ใช่หรือไม่?")) return;

      const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) };
      const url = `/api/v3.0/membernotes/delete/${note.objectId}`;
      
      pos({
        method: "post", // เปลี่ยนเป็น post
        url: url,
        headers: headers,
        data: { 
          shopObjectId: this.shopObjectId // ส่งค่าผ่าน body
        }
      })
      .then(() => {
        this.getNotes();
      })
      .catch((error) => {
        console.error("เกิดข้อผิดพลาดในการลบ:", error);
        alert("ไม่สามารถลบข้อมูลได้");
      });
    },
    formatDateTime(val) {
      if (!val) return "-";
      return moment(val).format("DD/MM/YYYY HH:mm");
    },
    formatGender(sex) {
      const genderMap = {
        0: "male",
        1: "female",
        2: "notSpectified",
      };
      return sex && sex.id in genderMap ? this.$t(genderMap[sex.id]) : "-";
    },
    ...util,
    showBirthDate(datetime) {
      return moment(datetime).format("DD/MM/YYYY");
    },
    showDatetime(datetime) {
      return moment(datetime).format("LLL");
    },
    catIcon(catName) {
      return catName.charAt(0).toUpperCase();
    },
    convertPoint(point) {
      if (point != undefined) {
        return util.convertNumber(point);
      } else {
        return 0;
      }
    },
    convertCurrency(number) {
      return util.convertCurrency(number);
    },
    showDate(createdAt) {
      return moment(createdAt).format("DD/MM/YYYY HH:mm");
    },
    async getNotes(){

      const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)}
      const res = await pos({
          method: 'get',
          url: '/api/v3.0/membernotes/data',
          params: { objectId: this.objectId ,shopObjectId: this.shopObjectId, uid: this.uid},
          headers: headers
      });
      console.log(res.data.data);
      this.notes = res.data.data || [];


    },
    getMemberByObjectId() {
      const uid = this.uid
      const objectId = this.objectId
      const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)}
      let url =
        '/api/v1.0/' + uid + '/Shop/getmemberbyobjectId/' + objectId + '/data'

      pos({
        method: "get",
        url: url,
        headers: headers,
      })
        .then((res) => {
          let doc = res.data.data.documents;

          if (doc) {
            this.data = doc;
            this.firstname =
              doc.name ||
              `${doc.firstname || doc.firstName || ""} ${
                doc.lastname || doc.lastName || ""
              }` ||
              "";
            this.deletedAt = doc.deletedAt;
            this.isMember = doc.isMember;
            console.log(this.data);
          } else {
            console.log("error");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMemberDashboard() {
      const uid = this.uid;
      let params = {
        shopObjectId: this.shopObjectId,
        memberObjectId: this.objectId,
      }
      const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)}

      pos({
        method: "get",
        url: "/api/v1.0/" + uid + "/Receipt/memberdashboard/data",
        params: params,
        headers: headers,
      })
        .then((res) => {
          let purchase = res.data.data;
          this.frequencyPurchase = purchase.frequencyPurchase;
          this.lastPurchase = purchase.lastPurchase;
          this.grandTotal = purchase.grandTotal;
          this.bill = purchase.bill;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTransaction() {
      this.$router.push("/member/" + this.objectId + "/gettransaction");
    },
    goback() {
      this.$router.push("/member/data");
    },
  },
};
</script>

<style>
.square-box {
  position: relative;
  width: 20%;
  overflow: hidden;
  border-radius: 5px;
}
.square-box:before {
  content: "";
  display: block;
  padding-top: 100%;
}
.circle {
  width: 100px; /* กำหนดขนาดชัดเจน */
  height: 100px; /* ต้องกำหนดให้เท่ากับ width */
  background-color: #acd7c6; /* สีพื้นหลังอ่อนกว่า success */
  border-radius: 50%; /* ทำให้เป็นวงกลม */

  /* ✅ จัดวางข้อความให้อยู่ตรงกลาง */
  display: flex;
  align-items: center;
  justify-content: center;

  /* ✅ ปรับขนาดตัวอักษร */
  font-size: 60px;
  font-weight: normal;
  color: #2f9576; /* สีตัวอักษร */
  text-align: center;
}
</style>
